import React, { ReactNode } from "react";

import Switch from "antd/es/switch";

import styles from "./SwitchLine.module.scss";

interface Props {
  disabled?: boolean;
  label?: ReactNode;
  onChange?: (value: boolean) => void;
  value?: boolean;
}

const SwitchLine: React.FC<Props> = ({ disabled, label, onChange, value }) => {
  return (
    <label className={styles.container}>
      <div className={styles.title}>{label}</div>
      <Switch checked={value} disabled={disabled} onChange={onChange} />
    </label>
  );
};

export default SwitchLine;
